import { Slider } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledSlider = styled(Slider)(({ color }) => ({
    ...color === "primary" && primary
  })
)

const primary = {
  color: "#94748E",

  "& [class*=MuiSlider-thumb]": {
    "&:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "0 0 0 .8rem rgba(148, 116, 142, .12)"
    }
  },

  "& [class*=MuiSlider-rail]": {
    backgroundColor: "#FFF1FC",
    opacity: 1
  },

  "& .MuiSlider-valueLabel": {
    width: "2.8rem",
    height: "2.8rem",
    fontSize: "1rem",
    fontWeight: 500
  },

  "& [class*=MuiSlider-valueLabel]": {
    backgroundColor: "#94748E",
    borderRadius: "50%",

    "&:before": {
      bottom: ".4rem",
      width: "1.4rem",
      height: "1.4rem",
      zIndex: -1
    }
  }
}
